// 登录
export const getLoginPhoneCode = ({
  phone,
  countryCode
}) => {
  return {
    url: '/api/over-sea-sms/session',
    method: 'post',
    data: {
      countryCode,
      phone
    }
  }
}

// 手机快捷登陆，获取状短信验证码
export const getFastLoginPhoneCode = ({
  phone,
  countryCode
}) => {
  return {
    url: '/api/over-sea-sms/message-code',
    method: 'post',
    data: {
      countryCode,
      phone
    }
  }
}

// 手机快捷登陆，未注册时自动注册  /api/v2/user/session
export const getFastLogin = ({
  phoneCode,
  countryCode,
  phone
}) => {
  return {
    url: '/api/v2/user/session',
    method: 'post',
    data: {
      phoneCode,
      countryCode,
      phone
    }
  }
}

// 通过userToken获取userId
export const getUserId = ({
  userToken
}) => {
  return {
    url: '/user/api/user/user-info/user-id',
    method: 'get',
    params: {
      userToken,
      platform: 'web'
    }
  }
}

export const loginPhone = ({
  phone,
  countryCode,
  phoneCode
}) => {
  return {
    url: '/api/user/login/phone-code',
    method: 'post',
    data: {
      user: {
        countryCode,
        phone
      },
      phoneCode
    }
  }
}

export const loginAccount = ({
  account,
  password
}) => {
  return {
    url: '/api/user/login',
    method: 'post',
    data: {
      userName: account,
      password
    }
  }
}

///api/user/logout
export const loginOut = () => {
  return {
    url: '/api/user/logout',
    method: 'get'
  }
}

export const getLoginStatus = headers => {
  if (headers) {
    return {
      url: '/api/user/login/timeout',
      method: 'get'
    }
  } else {
    return {
      url: '/api/user/login/timeout',
      method: 'get',
      headers
    }
  }
}

// 注册
export const getRegistPhoneCode = ({
  phone,
  countryCode
}) => {
  return {
    url: '/api/over-sea-sms/register',
    method: 'post',
    data: {
      countryCode,
      phone
    }
  }
}

export const registPhone = ({
  phone,
  countryCode,
  password,
  phoneCode
}) => {
  return {
    url: '/api/v2/user',
    method: 'post',
    data: {
      countryCode,
      phone,
      password,
      phoneCode
    }
  }
}

// 忘记密码
export const getForgotEmailCode = ({
  user,
  picCode
}) => {
  return {
    url: '/api/email/forgot',
    method: 'post',
    data: {
      user,
      picCode
    }
  }
}
// export const getForgotEmailCode = ({ email }) => {
//   return {
//     url: '/api/user/findEmail',
//     method: 'get',
//     params: {
//       email
//     }
//   };
// };

export const resetPasswordEmail = ({
  email,
  password,
  emailCode
}) => {
  return {
    url: '/api/v2/user/password/email',
    method: 'put',
    data: {
      email,
      password,
      emailCode
    }
  }
}

export const getForgotPhoneCode = ({
  countryCode,
  phone
}) => {
  return {
    url: '/api/over-sea-sms/message-code',
    method: 'post',
    data: {
      countryCode,
      phone
    }
  }
}

export const resetPasswordPhone = ({
  countryCode,
  phone,
  phoneCode,
  password
}) => {
  return {
    url: '/api/v2/user/password/phone',
    method: 'put',
    data: {
      countryCode,
      phone,
      phoneCode,
      password
    }
  }
}

// 用户关注相关操作
export const getFollowings = ({
  id,
  page,
  count
}) => {
  return {
    url: '/api/friendships/followings',
    method: 'get',
    params: {
      userId: id,
      page,
      count
    }
  }
}

export const getFollowers = ({
  id,
  page,
  count
}) => {
  return {
    url: '/api/friendships/followers',
    method: 'get',
    params: {
      userId: id,
      page,
      count
    }
  }
}

export const follow = ({
  id
}) => {
  return {
    url: '/api/friendships/follow',
    method: 'post',
    data: {
      destUserId: id
    }
  }
}

export const unfollow = ({
  id
}) => {
  return {
    url: '/api/friendships/unfollow',
    method: 'post',
    data: {
      destUserId: id
    }
  }
}
//用户关注主题相关操作
//1.关注主题
export const focusTheme = ({
  subjectId
}) => {
  return {
    url: '/api/subjects/follow',
    method: 'post',
    data: {
      subjectId: subjectId
    }
  }
}
//2.取消关注主题
export const cancelTheme = ({
  subjectId
}) => {
  return {
    url: `/api/subjects/follow/${subjectId}`,
    method: 'delete'
  }
}
//3.获取用户主题
export const getFocus = ({
  userId,
  page
}) => {
  return {
    url: `/api/subjects/${userId}/followed?${page}`,
    method: 'get'
  }
}

// 用户动态
export const getDynamics = ({
  article,
  userId,
  timestamp,
  count
}) => {
  return {
    url: '/api/community/dynamic/my-dynamics',
    method: 'get',
    params: {
      article,
      userId,
      timestamp,
      count
    }
  }
}

// 获取我的发表
export const getMyPublish = ({
  count,
  timestamp,
  status
}) => {
  return {
    url: '/api/post/my-publish',
    method: 'get',
    params: {
      count,
      timestamp,
      status
    }
  }
}
// 获取我的发表中各个模块的totalCount
export const getMyPublishEachPartTotalCount = () => {
  return {
    url: '/api/post/total/v1',
    method: 'get'
  }
}

export const getFavorite = ({
  page,
  limit
}) => {
  return {
    url: '/api/favorite/v4',
    method: 'get',
    params: {
      page,
      limit
    }
  }
}

export const getMyStock = ({}) => {
  return {
    url: '/api/userstock/v2',
    method: 'get'
  }
}

export const updatePassword = ({
  oldPass,
  newPass
}) => {
  return {
    url: '/api/user/updatePwd',
    method: 'post',
    data: {
      oldPassword: oldPass,
      user: {
        password: newPass
      }
    }
  }
}

export const updateInfo = ({
  userId,
  nick,
  sex,
  country,
  state,
  city,
  userBrief,
  professions
}) => {
  return {
    url: '/api/user/updateInfo',
    method: 'post',
    data: {
      professions,
      user: {
        userId,
        nick,
        sex,
        country,
        state,
        city,
        userBrief
      }
    }
  }
}

export const getMyInfo = ({
  userId
}) => {
  return {
    url: '/api/user/getDetail',
    method: 'get',
    params: {
      userId
    }
  }
}

export const delMyFav = ({
  source,
  refId
}) => {
  return {
    url: `/api/favorite/${source}/${refId}/v2`,
    method: 'delete'
  }
}

export const delMyPost = ({
  postId
}) => {
  return {
    url: `/api/post/${postId}/delete`,
    method: 'post'
  }
}

// /api/comment/my?page=1&count=10

export const commentMe = ({
  page,
  count
}) => {
  return {
    url: '/api/comment/my',
    method: 'get',
    params: {
      page,
      count
    }
  }
}

// 获取我的草稿：仅限专栏作家

export const getMyDraft = ({
  page,
  count
}) => {
  return {
    url: '/api/columnArticleDraft/getMyList',
    method: 'get',
    params: {
      page,
      count
    }
  }
}

// /api/columnArticleDraft/delMyOne?id=499

export const delMyDraft = ({
  id
}) => {
  return {
    url: '/api/columnArticleDraft/delMyOne',
    method: 'get',
    params: {
      id
    }
  }
}

// 同意合同
export const agreeAgreement = () => {
  return {
    url: '/api/user/agreement/v1?agree=true',
    method: 'put'
  }
}

// /api/user-purchased/v1{?page,limit}

export const myPurchase = ({
  page,
  limit
}) => {
  return {
    url: '/api/user-purchased/v1',
    method: 'get',
    params: {
      page,
      limit
    }
  }
}
